// extracted by mini-css-extract-plugin
module.exports = {"firmLogoIconContainer":"firmLogoIconContainer__3Ffbw","logoText":"logoText__2BHI8","logoTextSmall":"logoTextSmall__2vwep"};